import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: "studentslist",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "studentslist" */ "./components"),
        import(
          /* webpackChunkName: "studentslist" */ "StudentSetup/modules/StudentsModule"
        ),
        import(
          /* webpackChunkName: "studentslist" */ "StudentSetup/components/CreateStudent/containers/CreateStudentModule"
        ),
        import(
          /* webpackChunkName: "studentslist" */ "SchoolSetup/modules/StudentEnrollModalModule"
        ),
        import(
          /* webpackChunkName: "studentslist" */ "StudentSetup/components/EditStudent/containers/StudentDetailsModule"
        ),
        import(
          /* webpackChunkName: "studentslist" */ "SchoolSetup/modules/SchoolSetupModule"
        ),
        import(
          /* webpackChunkName: "studentslist" */ "ResetInviteAndSignInCodeModal/modules/ResetInviteAndSignInCodeModalModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
          importedModule6,
        ]) => {
          const component = importedModule0.default;
          const studentSetupModule = importedModule1;
          const createStudentModule = importedModule2;
          const studentEnrollModalModule = importedModule3.default;
          const studentDetailsModule = importedModule4;
          const schoolSetupReducer = importedModule5.default;
          const resetInviteAndSignInCodeModalModule = importedModule6.default;
          const reducer = studentSetupModule.default;
          const key = studentSetupModule.NAME;
          injectReducer(store, {
            key,
            reducer,
          });
          injectReducer(store, {
            key: createStudentModule.NAME,
            reducer: createStudentModule.default,
          });
          injectReducer(store, {
            key: "studentEnrollModal",
            reducer: studentEnrollModalModule,
          });
          injectReducer(store, {
            key: studentDetailsModule.NAME,
            reducer: studentDetailsModule.default,
          });
          injectReducer(store, {
            key: "schoolSetup",
            reducer: schoolSetupReducer,
          });
          injectReducer(store, {
            key: "resetInviteAndSignInCodeModal",
            reducer: resetInviteAndSignInCodeModalModule,
          });
          return component;
        }
      );
      //.catch(err => {
      // throw err;
      // });
    }),
  };
};
